export default "__VITE_ASSET__Ctgh2pMy__"